var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "helper-wrapper contents",
      class: { clsng: _vm.Global.tempHelperClosingOverlay },
      style: _vm.helperPos,
    },
    [
      _c("div", { staticClass: "duplicate-outer" }, [
        _c(
          "div",
          {
            staticClass: "btn main txt-blk",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.triggerContent.apply(null, arguments)
              },
            },
          },
          [
            _c("span", { staticClass: "hvr" }),
            _vm._v(" "),
            _c("span", { staticClass: "ico" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "26",
                    height: "26",
                    viewBox: "0 0 26 26",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM11.5 11.5V6.5H14.5V11.5H19.5V14.5H14.5V19.5H11.5V14.5H6.5V11.5H11.5Z",
                      fill: "black",
                    },
                  }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "txt" }, [_vm._v("Add new content")]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tooltip-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "tooltip-outer",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$parent.helperBgClick.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "tooltip" }, [
              _c("span", { staticClass: "ico" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "22",
                      height: "22",
                      viewBox: "0 0 27 27",
                      fill: "none",
                    },
                  },
                  [
                    _c("circle", {
                      attrs: {
                        cx: "13.5",
                        cy: "13.4999",
                        r: "12.25",
                        stroke: "url(#paint0_linear_1539_2667)",
                        "stroke-width": "2.5",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.5 10.2499C14.4665 10.2499 15.25 9.46638 15.25 8.49988C15.25 7.53338 14.4665 6.74988 13.5 6.74988C12.5335 6.74988 11.75 7.53338 11.75 8.49988C11.75 9.46638 12.5335 10.2499 13.5 10.2499ZM13 11.9999C12.4477 11.9999 12 12.4476 12 12.9999V17.9999C12 18.5522 12.4477 18.9999 13 18.9999H14C14.5523 18.9999 15 18.5522 15 17.9999V12.9999C15 12.4476 14.5523 11.9999 14 11.9999H13Z",
                        fill: "url(#paint1_linear_1539_2667)",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "defs",
                      [
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "paint0_linear_1539_2667",
                              x1: "27",
                              y1: "26.9999",
                              x2: "-2.28482",
                              y2: "24.2395",
                              gradientUnits: "userSpaceOnUse",
                            },
                          },
                          [
                            _c("stop", { attrs: { "stop-color": "#F3CA54" } }),
                            _vm._v(" "),
                            _c("stop", {
                              attrs: { offset: "1", "stop-color": "#FFBB36" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "paint1_linear_1539_2667",
                              x1: "15.25",
                              y1: "18.9999",
                              x2: "11.4229",
                              y2: "18.8968",
                              gradientUnits: "userSpaceOnUse",
                            },
                          },
                          [
                            _c("stop", { attrs: { "stop-color": "#F3CA54" } }),
                            _vm._v(" "),
                            _c("stop", {
                              attrs: { offset: "1", "stop-color": "#FFBB36" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "txt-main" }, [
                _vm._v(
                  "Start by adding your first content and configure its monetization!"
                ),
              ]),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }